import clsx from 'clsx';
import { FormattedNumber } from 'react-intl';
import { useDispatch } from 'react-redux';

import { setAmount } from 'store/payment/slice';

import styles from './index.module.scss';

const amountList = [1000, 2000, 10000, 25000];

const SelectAmount = () => {
  const dispatch = useDispatch();

  const select = (value: number) => {
    dispatch(setAmount(value.toString()));
  };

  return (
    <div className={clsx('flex gap-3 overflow-x-scroll', styles.amountList)}>
      {amountList.map((amount) => (
        <button
          type="button"
          key={amount}
          onClick={() => select(amount)}
          className="bg-sz-gray-400 flex-shrink-0 px-[10px] py-[5px] rounded-[12px] text-base font-medium hover:bg-sz-gray-200/50 transition-colors"
        >
          <FormattedNumber value={amount} maximumFractionDigits={0}>
            {(value) => <span>{value} ₸</span>}
          </FormattedNumber>
        </button>
      ))}
    </div>
  );
};

export { SelectAmount };
